import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-326faa56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }

import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetTablePagination',
  props: {
    pageNum: {},
    pageSize: {},
    count: {}
  },
  emits: ["update:pageNum", "update:pageSize"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const current = computed({
  get() {
    return props.pageNum
  },
  set(value: number) {
    emit("update:pageNum", value)
  }
})

const size = computed({
  get() {
    return props.pageSize
  },
  set(value: number) {
    emit("update:pageSize", value)
  }
})


return (_ctx: any,_cache: any) => {
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_pagination, {
      current: current.value,
      "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((current).value = $event)),
      pageSize: size.value,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((size).value = $event)),
      total: _ctx.count,
      showTotal: 
          (total, range) =>
            `显示第 ${range[0]} 到第 ${range[1]} 条记录，总共 ${total} 条记录`
        ,
      showQuickJumper: "",
      showSizeChanger: "",
      "hide-on-single-page": "",
      responsive: "",
      pageSizeOptions: ['10', '20', '30', '50']
    }, null, 8, ["current", "pageSize", "total", "showTotal"])
  ]))
}
}

})